export default __webpack_public_path__ + "6b93d219fc6d0ccaa7f538c5c710b0a5.svg";